import { Box } from "@mui/material"
import LogoTextImage from '../../assets/Icons/enphase_logo_with_text.png'
import { useStyles } from './style'

const Footer = () => {
  const classes = useStyles()
  return (
    <Box className={classes.container} width="100%" display="flex" alignItems="center" flexWrap="wrap">
      <Box>
        <img src={LogoTextImage} className={classes.logoImage} alt='logo' />
      </Box>
      <Box>
        <Box className={classes.text} sx={{ mx: '40px', my: 0.5 }}>
          {`© 2008-${new Date().getFullYear()} Enphase Energy Inc. All rights reserved.`}
          <Box component="span" ml={1}>
            <a
              className={classes.anchorlink}
              href="https://enphase.com/privacy "
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy
            </a>
            <span className={classes.anchorlink}> | </span>
            <a
              className={classes.anchorlink}
              href="https://enphase.com/terms "
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms
            </a>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default Footer